import LocalStorage from "./storage";
import { STORAGE } from "../config/constants";
import AuthApi from "@/general/api/authApi";
import auth, { AuthState } from "@/general/store/modules/auth";
import { UserInfo } from "@/general/store/models";
import loginInfo from "@/general/store/modules/loginInfo";

export default class AuthStorage {
  /**
   * Get token cookie
   * @returns string|null token
   */
  public static getToken = (): string | null => {
    return LocalStorage.getItem(STORAGE.ACCESS_TOKEN);
  };

  /**
   * Set token
   * @param string token
   * @returns void
   */
  public static setToken = (token: string): void => {
    LocalStorage.setItem(STORAGE.ACCESS_TOKEN, token);
  };

  /**
   * Delete token
   * @returns void
   */
  public static deleteToken = (): void => {
    LocalStorage.removeItem(STORAGE.ACCESS_TOKEN);
  };

  /**
   * Get Refresh  token cookie
   * @returns string|null token
   */
  public static getRefreshToken = (): string | null => {
    return LocalStorage.getItem(STORAGE.REFRESH_TOKEN);
  };

  /**
   * Set Refresh Token
   * @param string token
   * @returns void
   */
  public static setRefreshToken = (token: string): void => {
    LocalStorage.setItem(STORAGE.REFRESH_TOKEN, token);
  };

  /**
   * Delete Refresh Token
   * @returns void
   */
  public static deleteRefreshToken = (): void => {
    LocalStorage.removeItem(STORAGE.REFRESH_TOKEN);
  };

  /**
   * Get Token Time cookie
   * @returns string|null token
   */
  public static getTokenTime = (): string | null => {
    return LocalStorage.getItem(STORAGE.TOKEN_TIME);
  };

  /**
   * Set Token time
   * @param string token
   * @returns void
   */
  public static setTokenTime = (time: string): void => {
    LocalStorage.setItem(STORAGE.TOKEN_TIME, time);
  };

  /**
   * Delete Token time
   * @returns void
   */
  public static deleteTokenTime = (): void => {
    LocalStorage.removeItem(STORAGE.TOKEN_TIME);
  };

  private static async innerCheckLogin(retryCount: number) {
    const userDetails = LocalStorage.getItem("userDetails");
    const ssoFlg = loginInfo.isSso;
    let userDetailsJson: UserInfo = {} as UserInfo;
    if (userDetails) {
      userDetailsJson = JSON.parse(userDetails);
    }
    const accessToken = userDetailsJson?.access_token;
    if (!auth.authenticate && !accessToken) {
      await AuthApi.getICSession().then((result) => {
        const ic_session = JSON.parse(result);
        AuthStorage.getUserInfoRead(ic_session.companyCd);
      });
    }
    AuthStorage.sleep(2000);
    if (!auth.authenticate && !accessToken) {
      // 未ログイン状態はログインページに遷移する
      // lifeやshopでログインしてトップに遷移してきた場合、画面描画に必要なデータがlocalStorageに不足していることがあるため
      // ログインしているはずなのに auth.authenticateがfalse、accessTokenが空という状態があり得る
      // そのため、1度、今の画面を再ロードする処理を入れる
      let reloadFlag = LocalStorage.getItem("loginReload");
      if (reloadFlag == null) {
        reloadFlag = "0";
      }
      if (reloadFlag == String(retryCount)) {
        LocalStorage.removeItem("loginReload");
        if (ssoFlg) {
          // SSOログイン時は行き止まり画面へ遷移する
          window.location.href = "/session-time-out/";
        } else {
          // 未ログイン状態はログインページに遷移する
          const login_facade =
            process.env.VUE_APP_AUTH_FACADE +
            "?callback_authorization_start_uri=" +
            process.env.VUE_APP_API_DOMAIN +
            "/v1/top/auth-start";
          window.location.href = login_facade;
        }
      } else {
        let reloadCount = 0;
        if (reloadFlag) {
          reloadCount = Number(reloadFlag);
        }
        reloadCount += 1;
        LocalStorage.setItem("loginReload", String(reloadCount));
        // window.location.replace(window.location.href);
        const url = window.location.href;
        window.location.href = url;
        // window.location.reload();
      }
    } else {
      LocalStorage.removeItem("loginReload");
    }
  }

  public static checkLogin() {
    AuthStorage.innerCheckLogin(3);
  }

  public static checkLoginNoRetry() {
    // AuthStorage.innerCheckLogin(retryCount);
    const ssoFlg = loginInfo.isSso;
    const userDetails = LocalStorage.getItem("userDetails");
    let userDetailsJson: UserInfo = {} as UserInfo;
    if (userDetails) {
      userDetailsJson = JSON.parse(userDetails);
    }
    const accessToken = userDetailsJson?.access_token;
    let isLogin = false;
    if (auth && auth.authenticate && accessToken != null) {
      isLogin = true;
    }
    if (!isLogin) {
      LocalStorage.removeItem("loginReload");
      if (ssoFlg) {
        // SSOログイン時は行き止まり画面へ遷移する
        window.location.href = "/session-time-out/";
      } else {
        // 未ログイン状態はログインページに遷移する
        const login_facade =
          process.env.VUE_APP_AUTH_FACADE +
          "?callback_authorization_start_uri=" +
          process.env.VUE_APP_API_DOMAIN +
          "/v1/top/auth-start";
        window.location.href = login_facade;
      }
    }
  }

  private static async getUserInfoRead(companyCd: string) {
    await AuthApi.getUserInfoRead(companyCd).then((userInfoRead) => {
      if (userInfoRead) {
        const payload: AuthState = {} as AuthState;
        let users: UserInfo = {} as UserInfo;
        users = userInfoRead;
        payload.user = users;
        payload.authenticate = true;
        auth.setUser(payload);
        auth.setAuthentication(payload);
        // #59042対応によりpage_logo、point_logo、favicon、avatar、rankImagePc、rankImageSpをローカルストレージ上に保存しないように修正
        delete userInfoRead.page_logo;
        delete userInfoRead.point_logo;
        delete userInfoRead.favicon;
        delete userInfoRead.avatar;
        delete userInfoRead.rankImagePc;
        delete userInfoRead.rankImageSp;
      }
      LocalStorage.setItem("userDetails", JSON.stringify(userInfoRead));
      // LocalStorage.innerLocalStorage.userDetails = JSON.stringify(userInfoRead);
    });
  }

  private static sleep(waitMsec: number) {
    const startMsec = new Date();
    // 指定ミリ秒間だけループさせる（CPUは常にビジー状態）
    let curMsec = new Date();
    while (curMsec.getTime() - startMsec.getTime() < waitMsec) {
      curMsec = new Date();
    }
  }

}
